import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';

interface TabFormProps {
  children: ReactNode;
  labelKey: IntlKey;
  className?: string;
  onClose: () => void;
}

export function TabForm({ onClose, labelKey, className, children }: TabFormProps) {
  return (
    <>
      <button className="btn btn-flat-secondary float-end mx-4 my-3" onClick={onClose} data-e2e="close-user-prefs">
        <i className="icon">close</i>
      </button>
      <form className={classNames('mx-4', className)}>
        <h5 className="mt-3 mb-5" data-e2e="user-prefs-section-title">
          <FormattedMessage id={labelKey} />
        </h5>
        {children}
      </form>
    </>
  );
}

TabForm.displayName = 'TabForm';

interface SectionTitleProps {
  labelKey: IntlKey;
}

export const SectionTitle: FC<SectionTitleProps> = ({ labelKey }) => (
  <p className="text-medium mt-4 mb-2">
    <FormattedMessage id={labelKey} />
  </p>
);

SectionTitle.displayName = 'SectionTitle';
